import React from 'react';
import { TextField, Typography, Box } from '@mui/material';

const TimeQuestion = ({ question, questionNumber, answer, onAnswerChange }) => {
  const handleChange = (event) => {
    const { value } = event.target;

    // Check if the value is within the allowed range
    if (question.min && value < question.min) {
      return; // Prevent input smaller than the minimum
    }
    if (question.max && value > question.max) {
      return; // Prevent input larger than the maximum
    }

    onAnswerChange(value); // Update the answer
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="body1">
        {questionNumber}. {question.text}
      </Typography>
      <TextField
        type="time"
        value={answer || ""}
        onChange={handleChange}
        fullWidth
        margin="normal"
        slotProps={{input: {readOnly: onAnswerChange === null}}}
      />
    </Box>
  );
};

export default TimeQuestion;